import React, { useEffect, useState } from "react";
import { Card, Table, Button, Modal, Form, Input } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import PageHeader from "../../view/pageheader";
import TableComponent from "../CustomComponents/TableComponent";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getEventStagesHistory } from "../../store/reducer/jobSlice";

const EventStagesHistory = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { eventStagesHistoryData } = useSelector((state) => state.jobs);
    const { count: totalCount, data: tableData } = eventStagesHistoryData || {};
    const barcode = window.atob(id);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [eventFields, setEventFields] = useState([]);
    function getData(payload = {}) {
        const barcode = window.atob(id);
        dispatch(getEventStagesHistory({ ...payload, barcode }));
    }

    useEffect(() => {
        getData();
    }, []);

    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
        },
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
        },
        {
            title: "Stage",
            dataIndex: "event_name",
            key: "event_name",
        },
        {
            title: "User",
            dataIndex: "user_name",
            key: "user_name",
        },
        // {
        //     title: "State",
        //     dataIndex: "stage_name",
        //     key: "stage_name",
        // },
        {
            title: "Events Recorded",
            key: "details",
            render: (_, record) => {
                let fields = [];
                try {
                    fields = JSON.parse(record.event_field_data || "[]");
                } catch (err) {
                    fields = [];
                }

                return (
                    <>
                        {/* Event History button */}
                        <Button
                            type="link"
                            icon={<EyeOutlined />}
                            onClick={() => {
                                setEventFields(fields);
                                setIsModalOpen(true);
                            }}
                        >
                            View Events
                        </Button>

                        {/* Inline preview */}
                        <span style={{ marginLeft: 8 }}>
                            {fields.length > 0 ? (
                                fields.map((f, i) => (
                                    <span key={f.fieldId}>
                                        <strong>{f.fieldName}:</strong> {f.value || "-"}
                                        {i < fields.length - 1 && ", "}
                                    </span>
                                ))
                            ) : (
                                <span>-</span>
                            )}
                        </span>
                    </>
                );
            },
        },

    ];

    return (
        <>
            <PageHeader
                HeaderText="Box Event History"
                Breadcrumb={[{ name: "Box Event History" }]}
                backgroundUrlName={true}
            />
            <Card title={`Box Event History`}>
                <h6>Box Number - {barcode}</h6>
                <TableComponent columns={columns} dataSource={tableData} />
            </Card>

            {/* Modal for Event Fields */}
            <Modal
                title="Event Details"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={600}
            >
                <Form layout="vertical">
                    {eventFields.length > 0 ? (
                        eventFields.map((f) => (
                            <Form.Item key={f.fieldId} label={f.fieldName}>
                                <Input value={f.value || "-"} readOnly />
                            </Form.Item>
                        ))
                    ) : (
                        <p>No event details available</p>
                    )}
                </Form>
            </Modal>
        </>
    );
};

export default EventStagesHistory;
